/**
 * Per-(model, relationship) display config.
 *
 * Per-rel knobs:
 *   - `label`: rename the tab / card heading without re-scaffolding.
 *   - `mode`: force render as "tab" / "card" / "hidden". Defaults are
 *     ToMany → tab, ToOne → card, with a built-in hide list (see
 *     `getRelationshipMode` in `display-resolver`).
 *
 * Keys: source model class name → rel property name → config.
 *
 * No codegen run or backend restart required after edits.
 */

export type RelationshipMode = "tab" | "card" | "hidden";

export const relationshipDisplay: Record<
  string,
  Record<string, { label?: string; mode?: RelationshipMode }>
> = {
  // A project's reference pins are managed on its Versions page (Reference
  // pins panel); the scaffolded IslandPin routes are excluded
  // (route-overrides.json), so the generated tab has no page.
  Project: {
    island_pins: { mode: "hidden" },
  },
  // Examples — uncomment / edit per app:
  // PropertyType: {
  //   values: { label: "Used By" },
  //   workspace: { mode: "hidden" },
  // },
};
